import React from 'react';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { Save } from 'lucide-react';

const AdPagesTab = ({ adPages, setAdPages, saving, onSave }) => {
  const pages = [
    { key: 'home', label: 'Homepage', description: 'Homepage with profile grid' },
    { key: 'search', label: 'Search Page', description: 'Search and filter results' },
    { key: 'detail', label: 'Profile Detail', description: 'Individual profile pages' },
    { key: 'blog', label: 'Blog Pages', description: 'Blog list and post pages' },
    { key: 'contact', label: 'Contact Page', description: 'Contact form and info' },
    { key: 'create_listing', label: 'Create Listing', description: 'New listing creation form' },
    { key: 'edit_listing', label: 'Edit Listing', description: 'Listing edit form' },
    { key: 'dynamic_page', label: 'Dynamic Pages', description: 'Pages created from admin panel' }
  ];

  return (
    <div className="bg-zinc-900 rounded-lg border border-zinc-800 p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-semibold text-white">Ad Display Settings</h2>
          <p className="text-zinc-400 text-sm mt-1">Control which pages display ads</p>
        </div>
        <Button onClick={onSave} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700">
          <Save className="w-4 h-4 mr-2" />
          Save Changes
        </Button>
      </div>

      <div className="space-y-4">
        {pages.map((page) => (
          <div 
            key={page.key}
            className={`flex items-center justify-between p-4 rounded-lg border ${
              adPages[page.key] ? 'bg-zinc-800 border-emerald-500/30' : 'bg-zinc-800/50 border-zinc-700'
            }`}
          >
            <div>
              <p className="text-white font-medium">{page.label}</p>
              <p className="text-zinc-400 text-sm">{page.description}</p>
            </div>
            <div className="flex items-center gap-3">
              <span className={`text-sm ${adPages[page.key] ? 'text-emerald-400' : 'text-zinc-500'}`}>
                {adPages[page.key] ? 'Ads On' : 'Ads Off'}
              </span>
              <Switch
                checked={adPages[page.key]}
                onCheckedChange={(checked) => setAdPages({ ...adPages, [page.key]: checked })}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdPagesTab;
